import { render } from "./PromotionCollections.vue?vue&type=template&id=2adafbc8"
import script from "./PromotionCollections.vue?vue&type=script&lang=js"
export * from "./PromotionCollections.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__